import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "Ubuntu",
  },
  palette: {
    primary: {
      main: "#4B7DB4",
      contrastText: "#fafafa",
    },
    secondary: {
      main: "#966e01",
      contrastText: "#263238",
    },
    background: {
      paper: "#FCFFF3",
      default: "#ECF5EB",
    },
  },
});

export default theme;
